import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import React, { useCallback, useEffect, useMemo, useRef } from 'react';
import useFocusNew from '../common/effects/useFocusNew';
import styles from './menu-item.module.scss';
const MenuItem = React.memo(({ disabled, name, isDivider, handleSelection, focus, size = 'sm', isDark, RTL = false, }) => {
    const ref = useRef(null);
    const onRef = useCallback((node) => {
        if (node) {
            ref.current = node;
        }
    }, [focus]);
    const handleClick = useCallback((ev) => {
        ev.preventDefault();
        ev.stopPropagation();
        if (!disabled && name) {
            handleSelection?.(name);
        }
    }, []);
    const menuItemClass = useMemo(() => classNames(styles.item, {
        [styles.disabled]: disabled,
        [styles.divider]: isDivider,
        [styles.dark]: isDark,
        [styles[size]]: true,
        [styles.rtl]: RTL,
    }), [isDark]);
    useEffect(() => {
        if (focus) {
            ref.current?.focus();
        }
    }, [focus]);
    useFocusNew(ref, handleClick);
    return (_jsx("li", { className: menuItemClass, onClick: handleClick, ref: onRef, role: "menuitem", tabIndex: 0, children: !isDivider && _jsx("span", { className: styles.name, children: name }) }));
}, (prev, next) => {
    return prev.disabled === next.disabled && prev.focus === next.focus;
});
MenuItem.displayName = 'MenuItem';
export { MenuItem };
